"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given date is same as specified date.
 *
 * @export
 * @class IsSameAsValidator
 * @implements {PropertyValidator<Date>}
 */
class IsSameAsValidator {
    constructor(date) {
        this.date = date;
    }
    isValid(input) {
        if (input) {
            return input.getTime() === this.date.getTime();
        }
        return false;
    }
}
exports.IsSameAsValidator = IsSameAsValidator;
//# sourceMappingURL=IsSameAsValidator.js.map